export default __webpack_public_path__ + "static/media/icon-buss-tower-traslado.149e0e84.svg";